export default __webpack_public_path__ + "static/media/5.153cf3ea.webp";